const OL_REGEX = /<ol>/g
const UL_REGEX = /<ul>/g
const LI_REGEX = /<li>/g
const P_REGEX = /<p>/g

export const normalizeFaqAnswer = (html) =>
  html
    .replace(OL_REGEX, '<ol class="list-decimal">')
    .replace(UL_REGEX, '<ul class="list-disc pl-4">')
    .replace(LI_REGEX, '<li class="mb-4">')
    .replace(P_REGEX, '<p class="mb-4">')
